let options = {
  sendIntentMediaStats: true,
  enableHotelsPopunder: true,
  sendGAEvent: true,
};

export function setOptions(newOptions = {}) {
  options = { ...options, ...newOptions };
}

export function getOptions() {
  return options;
}
